import VueRouter from "vue-router";
import Vue from "vue";
import App from "@/App.vue";
import VueScrollTo from "vue-scrollto";
import VueObserveVisibility from "vue-observe-visibility";

import router from "./router";
import "./directives";
import config from "./config";
import store from "./store";

import Default from "@/layouts/Default.vue";
Vue.component("default-layout", Default);

import Index from "@/layouts/Index.vue";
Vue.component("index-layout", Index);

import Static from "@/layouts/Static.vue";
Vue.component("static-layout", Static);

import IndexRedesign from "@/layouts/redesign/Index.vue";
Vue.component("index-redesign-layout", IndexRedesign);

import DefaultRedesign from "@/layouts/redesign/Default.vue";
Vue.component("default-redesign-layout", DefaultRedesign);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import VueHead from "vue-head";
Vue.use(VueHead);

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import { VueMasonryPlugin } from "vue-masonry";
Vue.use(VueMasonryPlugin);

Vue.prototype.$config = config;
Vue.use(VueRouter);

Vue.use(VueScrollTo);

Vue.use(VueObserveVisibility);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
